module.exports = __webpack_public_path__ + "static/img/yfrz_image.3e2ed2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/supplyFinance/yfrz_image.png
// module id = jnMf
// module chunks = 44